import React from 'react';

interface IProps {
  fillColor?: string;
}

export const ListIcon: React.FC<IProps> = (props: IProps) => {
    return (
        <svg width="21" height="21" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" fill={props.fillColor ?? "#FFFFFF"} >
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5 .833C5 .373 5.398 0 5.889 0H20.11c.491 0 .889.373.889.833v3.334c0 .46-.398.833-.889.833H5.89C5.398 5 5 4.627 5 4.167V.833zm14.222 2.5H6.778V1.667h12.444v1.666zM5 8.833c0-.46.398-.833.889-.833H20.11c.491 0 .889.373.889.833v3.334c0 .46-.398.833-.889.833H5.89C5.398 13 5 12.627 5 12.167V8.833zm1.778.834h12.444v1.666H6.778V9.667zM5.889 16c-.491 0-.889.373-.889.833v3.334c0 .46.398.833.889.833H20.11c.491 0 .889-.373.889-.833v-3.334c0-.46-.398-.833-.889-.833H5.89zm13.333 1.667H6.778v1.666h12.444v-1.666z"/>
            <path d="M1.5 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM3 10.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM1.5 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>
        </svg>
    )
}

export default ListIcon;